import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  ref: "root",
  class: "reports-container"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_view = _resolveComponent("router-view")!
  const _component_el_config_provider = _resolveComponent("el-config-provider")!

  return (_ctx.isBackofficeMode)
    ? (_openBlock(), _createBlock(_component_el_config_provider, {
        key: 0,
        namespace: "ep-reports"
      }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_1, [
            _createVNode(_component_router_view)
          ], 512 /* NEED_PATCH */)
        ]),
        _: 1 /* STABLE */
      }))
    : _createCommentVNode("v-if", true)
}